import { expValEquals } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

/**
 * Eligibility for the "Rovo Agents for you" For You section.
 *
 * Gated on the Labs/Beta AI guards (`isAdminHubAIEnabled && isAIEarlyAccessEnabled`),
 * Rovo LLM availability, plus the `cc_ootb_for_you_agent_card_nudge` experiment.
 */
export const useRovoAgentsForYouEligibility = (): boolean => {
	const { isAdminHubAIEnabled, isAIEarlyAccessEnabled, isRovoLLMEnabled } = useSessionData();

	return (
		// Each expVal() is evaluated inline, experiment-last per lint rules.
		isAdminHubAIEnabled &&
		isAIEarlyAccessEnabled &&
		isRovoLLMEnabled &&
		expValEquals('cc_ootb_for_you_agent_card_nudge', 'cohort', 'experiment')
	);
};
